import React from 'react'
import PropTypes from 'prop-types'
import { Transition, TransitionGroup } from 'react-transition-group'
import { gsap, ScrollSmoother, ScrollTrigger } from 'gsap-wrapper'
import ThemeProvider from 'styles/theme-provider'
import { TransitionStatusProvider } from 'styles/transition-status-provider'

import CookiesBanner from 'components/ui-elements/cookies-banner'
import 'styles/fonts.css'
import GlobalStyle from 'styles/global-styles'
import { LayoutWrapper, PageWrapper, ContentWrapper } from './index.styled'
import useWindowSize from 'styles/window-size'

const LayoutContent = ({ children, location, scrollSmoother }) => {
  const { width } = useWindowSize()

  return (
    <TransitionGroup component={null}>
      <Transition
        key={location.pathname}
        timeout={{ enter: 100, exit: 0 }}
        onEntered={() => {
          setTimeout(() => {
            ScrollTrigger.refresh()
            if (width < 768) {
              if (scrollSmoother.current) scrollSmoother.current.scrollTop(0, false)
              else window.scrollTo(0, 0)
            }
          }, 10)
        }}
      >
        {(status) => (
          <div className={`page ${status}`}>
            <TransitionStatusProvider status={status}>
              <LayoutWrapper>{children}</LayoutWrapper>
            </TransitionStatusProvider>
          </div>
        )}
      </Transition>
    </TransitionGroup>
  )
}

const Layout = (props) => {
  const { children, location } = props
  const refWrapper = React.useRef(null)
  const scrollSmoother = React.useRef(null)

  React.useLayoutEffect(() => {
    const gsapContext = gsap.context(() => {
      scrollSmoother.current = ScrollSmoother.create({
        content: '.home-content',
        wrapper: '.home-wrapper',
        smooth: 2,
        effects: true
        // smoothTouch: 1
      })

      // parallax
      const mediaQueryAnimation = gsap.matchMedia()
      mediaQueryAnimation.add('(min-width: 768px)', () => {
        gsap.utils.toArray('.parallax').forEach(function (container) {
          scrollSmoother.current.effects(container.querySelector('.content'), {
            speed: '0.5s'
          })
        })
      })
      return () => mediaQueryAnimation.revert()
    }, [refWrapper])

    return () => gsapContext.revert()
  }, [children])

  return (
    <ThemeProvider scrollSmoother={scrollSmoother}>
      <div className='home-wrapper' ref={refWrapper}>
        <div className='home-content'>
          <PageWrapper className={location.pathname === '/architecture/' ? 'architecture-page' : ''}>
            <GlobalStyle />
            <ContentWrapper>
              <LayoutContent
                location={location}
                scrollSmoother={scrollSmoother}
              >
                {children}
              </LayoutContent>
            </ContentWrapper>
          </PageWrapper>
        </div>
        <CookiesBanner />
      </div>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired
}

export default Layout
